export function getTotalTravelTime(stops: { travelDurationMinutes?: number | null }[] | undefined): number {
  if (!stops) return 0;
  return stops.reduce((sum, stop) => sum + (stop.travelDurationMinutes ?? 0), 0);
}
